import type { FC } from 'react';
import { useWindowDimensions } from 'react-native';
import type ApiFeaturedItem from 'src/core/models/api/ApiFeaturedItem';
import Dimens from 'src/core/utils/Dimens';
import { clamp } from 'src/core/utils/Numbers';
import Translations from 'src/core/utils/Translations';
import CarouselSection from 'src/presentation/components/molecules/CarouselSection';
import CustomFeaturedItem from 'src/presentation/components/organisms/CustomFeaturedItem';
import ProductFeaturedItem from 'src/presentation/components/organisms/ProductFeaturedItem';

const NAV_TOP_HEIGHT = Dimens.size128;
const NAV_BOTTOM_HEIGHT = Dimens.size91;

interface Props {
	items: ApiFeaturedItem[];
	page: number;
	setPage: (page: number) => void;
}

const FeaturedItemsSlider: FC<Props> = ({ items, page, setPage }) => {
	const { width: windowWidth, height: windowHeight } = useWindowDimensions();

	const cardWidth = Math.min(windowWidth - Dimens.carouselPeek100, Dimens.size380);
	const cardHeight = clamp(windowHeight - NAV_TOP_HEIGHT - NAV_BOTTOM_HEIGHT, Dimens.size450, Dimens.size500);

	if (items.length === 0) {
		return null;
	}

	return (
		<CarouselSection
			cardWidth={cardWidth}
			page={page}
			pageCount={items.length}
			setPage={setPage}
			subtitle={Translations.homeFeaturedSubtitle}
			title={Translations.homeFeatured}
		>
			{items.map((item) =>
				item.featured_item_type === 'PRODUCT' ? (
					<ProductFeaturedItem height={cardHeight} item={item} key={item.id} width={cardWidth} />
				) : (
					<CustomFeaturedItem height={cardHeight} item={item} key={item.id} width={cardWidth} />
				),
			)}
		</CarouselSection>
	);
};

export default FeaturedItemsSlider;
